export const PROPERTIES_LOAD_START = 'PROPERTIES_LOAD_START'
export const PROPERTIES_LOAD_END = 'PROPERTIES_LOAD_END'
export const PROPERTIES_CREATE_START = 'PROPERTIES_CREATE_START'
export const PROPERTIES_CREATE_END = 'PROPERTIES_CREATE_END'
export const SELECT_PROPERTY = 'SELECT_PROPERTY'
